import request from '../../axios';
import {IShopAdvertisementsPayload, IShopAdvertisementsResponse} from './types';

interface IProps {
  pageParam: number;
  payload?: IShopAdvertisementsPayload;
}

export const getShopAdvertisementsByInput = async ({
  pageParam,
  payload,
}: IProps) => {
  const {enabled, storeGuid, input_guid, input_group, ...rest} = payload ?? {};

  const {data}: {data: IShopAdvertisementsResponse} = await request.get(
    `/api/v2/store/list-store-input-advertisement/${storeGuid}`,
    {
      params: {
        ...rest,
        ...(input_guid ? {input_guid} : {input_group}),
        page: pageParam,
        page_size: payload?.page_size ?? 10,
      },
    },
  );

  return data;
};
